import $ from 'jquery';

import init from './init';
import pjax, { addMetadataHook } from './pjax';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import showBody from './showBody';

init();
pjax();

const $html = $('html');

addMetadataHook('htmlClasses', {

	init(value, oldValue) {

		if (Array.isArray(oldValue)) {
			$html.removeClass(oldValue.join(' '));
		}

		if (Array.isArray(value)) {
			$html.addClass(value.join(' '));
		}
	},
});

modalSection();
headerSection();
showBody();


// WEBPACK FOOTER //
// ./source/scripts/main.js